<template>
  <div>
    <el-drawer
      title="🔰 權限控制面板"
      :visible.sync="syncShow"
      :append-to-body="true"
      size="700px"
      @close="onClose"
    >
      <div style=" padding: 20px">
        <div class="text-white">
          <el-tabs v-model="curTab" type="card">
            <el-tab-pane label="店家方案" />
            <el-tab-pane label="使用者權限" />
            <el-tab-pane label="權限進階檢視" />
            <el-tab-pane label="權限資訊查詢" />
          </el-tabs>
        </div>

        <div v-show="curTab === '0' || curTab === '1'" class="filters-container">
          <BaseElInput v-model="search" clearable placeholder="搜尋 featureKey" />
          <BaseElCheckbox v-model="testRoute"><span class="test-route-checkbox">測試路由</span></BaseElCheckbox>
          <!-- <div class="ml-auto flex gap-2">
            <el-button size="mini" type="warning" @click="openShopEditor">編輯店家 JSON</el-button>
            <el-button size="mini" type="warning" @click="openUserEditor">編輯使用者 JSON</el-button>
          </div> -->
        </div>

        <div>
          <ShopFeatureSelector v-show="curTab === '0'" :search="search" :testRoute="testRoute" @query-feature="navigateToQuery" />
          <UserFeatureSelector v-show="curTab === '1'" :search="search" :testRoute="testRoute" @query-feature="navigateToQuery" />
          <PermissionAnalyzer v-show="curTab === '2'" :testRoute="testRoute" @query-feature="navigateToQuery" />
          <FeatureKeyInfoQuery v-show="curTab === '3'" :feature-key="queryFeatureKey" @clear-feature-key="queryFeatureKey = ''" />
        </div>
      </div>
    </el-drawer>
    <ShopFeatureEditor :visible.sync="showShopEditor" :initialData="shopInitial" @save="onSaveShop" />
    <UserFeatureEditor :visible.sync="showUserEditor" :initialData="userInitial" @save="onSaveUser" />
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'
import ShopFeatureSelector from './components/ShopFeatureSelector.vue'
import UserFeatureSelector from './components/UserFeatureSelector.vue'
import PermissionAnalyzer from './components/PermissionAnalyzer.vue'
import FeatureKeyInfoQuery from './components/FeatureKeyInfoQuery.vue'
import ShopFeatureEditor from './components/ShopFeatureEditor.vue'
import UserFeatureEditor from './components/UserFeatureEditor.vue'
import store from '@/store'
import { usePermissions } from '@/use/permissions'
import { get } from 'lodash'

export default defineComponent({
  name: 'FeatureKeyDebugger',
  components: { ShopFeatureSelector, UserFeatureSelector, ShopFeatureEditor, UserFeatureEditor, PermissionAnalyzer, FeatureKeyInfoQuery },
  props: {
    show: Boolean,
  },
  setup () {
    const targetRef = ref(null)
    const search = ref(null)
    const curTab = ref('')
    const syncShow = computed({
      get () {
        return get(store.state, 'app.toggle.featureKeyDebugger')
      },

      set (data) {
        store.commit('app/SET_TOGGLE', { key: 'featureKeyDebugger', toggle: data })
      },
    })

    const testRoute = ref(false)
    const showShopEditor = ref(false)
    const showUserEditor = ref(false)

    const shopInitial = ref('')
    const userInitial = ref('')

    // 查詢相關數據
    const queryFeatureKey = ref('')

    const { refreshRoutes, originShopPlanFeatures, originShopUserFeatures } = usePermissions()

    const onClose = () => {
      store.commit('app/SET_TOGGLE', { key: 'featureKeyDebugger', toggle: false })
    }

    const openShopEditor = () => {
      // load current shop selector data if available (best-effort)
      const data = originShopPlanFeatures.value
      try {
        shopInitial.value = JSON.stringify(data, null, 2)
      } catch (e) {
        shopInitial.value = String(data)
      }
      showShopEditor.value = true
    }

    const openUserEditor = () => {
      const data = originShopUserFeatures.value
      try {
        userInitial.value = JSON.stringify(data, null, 2)
      } catch (e) {
        userInitial.value = String(data)
      }
      showUserEditor.value = true
    }

    const onSaveShop = async (parsed) => {
      // commit parsed shop features into store
      try {
        const features = parsed || {}
        store.commit('permission/SET_RAW_PERMISSIONS', { key: 'shopPlanFeatures', data: features })
        if (testRoute.value) await refreshRoutes(true)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('onSaveShop commit failed', e)
      }
    }

    const onSaveUser = async (parsed) => {
      try {
        const features = parsed || {}
        store.commit('permission/SET_RAW_PERMISSIONS', { key: 'userFeatures', data: features })
        if (testRoute.value) await refreshRoutes(true)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('onSaveUser commit failed', e)
      }
    }

    // 切換到查詢頁面並設置 featureKey
    const navigateToQuery = (featureKey) => {
      console.log('navigateToQuery', featureKey)
      queryFeatureKey.value = featureKey
      curTab.value = '3' // 切換到權限資訊查詢頁面
    }

    return {
      targetRef,
      search,
      curTab,
      testRoute,
      onClose,
      syncShow,
      showShopEditor,
      showUserEditor,
      openShopEditor,
      openUserEditor,
      shopInitial,
      userInitial,
      onSaveShop,
      onSaveUser,
      queryFeatureKey,
      navigateToQuery,
    }
  },
})
</script>

<style lang="postcss" scoped>
::v-deep .el-drawer {
  @apply bg-black bg-opacity-30;
  backdrop-filter: blur(5px);
}
::v-deep .el-tabs__item {
  @apply text-gray-40;
}
::v-deep .el-tabs__item.is-active {
  @apply text-[#58f993];
}
::v-deep .el-dialog__close{
  @apply text-[#58f993];
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  @apply text-[#58f993];
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  @apply bg-[#58f993];
}

::v-deep .el-drawer__header span {
  @apply text-[#58f993];
}

.filters-container {
  @apply flex items-center gap-[10px];
}

.area-title {
  @apply text-[#58f993] text-lg font-medium mb-[10px];
}

.test-route-checkbox {
  @apply text-warning;
}
</style>
